var appConfig = {

    "env": process.env.REACT_APP_ENV.trim(),
    "REACT_APP_NAME": process.env.REACT_APP_NAME.trim()

};

let authToken;
if (appConfig.REACT_APP_NAME == "MONEYFY") {
     authToken = {
        "DEVELOPMENT": "MTI4OjoxMDAwMDo6M2U0NGViY2Q1OTRkMmFlOWNjMDBjZjhkNWQ4ZWM5M2I6OmNlMDA3ZTQ4NDg5OTE0NWE1MGM1N2E2ZjVjYzlhNjZmOjpVUnNaU3I0WkM2akRQMFgxUkUxY0hXQ29HWFRXMGZZa2F5WTZURGtrMFVJQTRvbjVQSFB4bGUwQUZFcmVCeUk4",
        "PRODUCTION": "MTI4OjoxMDAwMDo6M2Y0M2RhMGM5MGNiYWNlZjcwNDdiYTBiYzlhZGY0YWY6OjlkOGQ3OWVhOWYzYzM0ZjlhNzMwMGIxMzU2ZjdjNDhlOjpWdmhaYUhXUVZDWEpCSUFJb3V4WXV0WDkzdlhyV0R5QllZTjZLSVE0dE1sbXlyaVkzMUJYTUQvbmoyTHdSU0dn"
    }
} else {
     authToken = {
        "DEVELOPMENT": "MTI4OjoxMDAwMDo6NTEyYWZhZjk2MjhiOWFiZDMwNDBjZmIxNmQxY2E2MTI6OjUxYWYxNmM1NjdmOWIzOWZjNDJiZjRjMTZkYTVjZjlkOjpHY2lDaUZKU0paaFNUTFN5WnREbG9OSGhZYm9Nd2w5SWk3YTVlQWFJYVl3PQ==",
        "PRODUCTION": "MTI4OjoxMDAwMDo6MmFkZTY4NTc2M2FmNTZmOWExOTUwM2E1OTMzODhjODk6OmQwZWEzOWFlMzBkMmFiMzNiNGYyYWM5OGNiZTZkMjgyOjozemh5ZXhUc09PMHFhZWdENTBCTmlrYXFkNjN0K3llOHhqNEN2Zm5IRmE4PQ=="
    }

}


export default authToken;